import React, {Component} from 'react';
import i18n from "../../../i18n";
import {withError, withStyleguide} from "cw-styleguide-react";
import GlossaryLandingView from "../views/GlossaryLandingView";
import {withTranslation} from "react-i18next";
import {route} from "../../../routes";

class GlossaryLandingController extends Component {

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      glossary: []
    };
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.setState({
      glossary: this.generateGlossary(this.props.jobs)
    });

    this.props.styleguide.setLanguageUrl(route('glossary', null, i18n.language === 'en' ? 'cy' : 'en'));
  }


  /**
   * generateGlossary
   * @param jobs
   * @returns {*[]}
   */
  generateGlossary(jobs) {
    const alphabet = {
      en: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      cy: ['A', 'B', 'C', 'CH', 'D', 'DD', 'E', 'F', 'FF', 'G', 'NG', 'H', 'I', 'J', 'L', 'LL', 'M', 'N', 'O', 'P', 'PH', 'R', 'RH', 'S', 'T', 'TH', 'U', 'W', 'Y']
    };
    let glossary = [];
    alphabet[i18n.language].forEach(letter => {
      glossary.push({
        letter: letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase(),
        jobs: []
      });
    });

    jobs.sort((jobA, jobB) => {
      let careerA = jobA.name.toUpperCase();
      let careerB = jobB.name.toUpperCase();
      return (careerA < careerB) ? -1 : (careerA > careerB) ? 1 : 0;
    }).forEach(job => {
      glossary.forEach(term => {
        let career = job.name.toUpperCase();
        let letter = term.letter.toUpperCase();
        if (letter === career.substring(0, term.letter.length)) {
          if (term.letter.length === 1 && alphabet[i18n.language].includes(career.substring(0, (term.letter.length + 1)))) {
            return;
          }
          term.jobs.push(job);
        }
      });
    });

    return glossary;
  }

  render() {
    return (
      <GlossaryLandingView {...this.state} {...this.props}/>
    );
  }
}


export default withStyleguide(withError(withTranslation('local')(GlossaryLandingController)));
